import * as React from 'react';
import { IDisclaimer } from '../../../../../../infrastructure/interfaces';

export interface IDisclimers {
  disclaimers: IDisclaimer[];
  className: string;
}

export interface IDisclaimers {
  disclaimers: IDisclaimer[];
  className: string;
}

export default class PrintDisclaimers extends React.Component<IDisclaimers> {
  constructor(props: IDisclaimers) {
    super(props);
  }
  buildMarkup = (key: any, className: string, value: any) => {
    return (
        <p
            key={key}
            className={className}
            dangerouslySetInnerHTML={{ __html: value }}>
        </p>
    );
  }
  render() {
    const {
      disclaimers,
      className,
    } = this.props;

    return (
        disclaimers!.map((disc, key) => {
          return this.buildMarkup(key, className, disc.description);
        })
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/PrintDisclaimers.tsx